import { PackingTypeSale } from 'enums/packingTypeSale';
import Packing from 'model/Packing';
import ProductOffer from 'model/ProductOffer';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProducerUrl } from './useProducerUrl';

interface OfferNavigationParams {
  producerUrl: string;
  offerId: number;
  offerType: number;
  packingSelectedId: number;
  selectedTypeSale: PackingTypeSale;
}

interface ProductCardHandlers {
  handleShowDetails: (
    product: ProductOffer,
    packingSelected: Packing,
    isExclusiveOffer?: boolean,
  ) => void;
}

interface UseProductCardActionsParams {}

export const useProductCardActions =
  ({}: UseProductCardActionsParams = {}): ProductCardHandlers => {
    const navigate = useNavigate();
    const producerUrl = useProducerUrl();

    const validateNavigationParams = useCallback(
      (producerUrl: string, packingSelected: Packing | undefined): boolean =>
        Boolean(producerUrl && packingSelected?.id),
      [],
    );

    const buildOfferParams = useCallback(
      (
        product: ProductOffer,
        packingSelected: Packing,
        producerUrl: string,
      ): OfferNavigationParams => ({
        producerUrl,
        offerId: product.offerId ?? product.id,
        offerType: product.offerType ?? 0,
        packingSelectedId: packingSelected.id,
        selectedTypeSale: PackingTypeSale.Packing,
      }),
      [],
    );

    const buildDetailsRoute = useCallback(
      (params: OfferNavigationParams): string =>
        `/${params.producerUrl}/offer-details/${params.offerId}/${params.offerType}/${params.packingSelectedId}/${params.selectedTypeSale}`,
      [],
    );

    const handleShowDetails = useCallback(
      (
        product: ProductOffer,
        packingSelected: Packing,
        isExclusiveOffer = false,
      ) => {
        if (!validateNavigationParams(producerUrl, packingSelected)) {
          console.warn('Parâmetros insuficientes para navegação de detalhes:', {
            producerUrl: producerUrl || 'undefined',
            packingSelectedId: packingSelected?.id ?? 'undefined',
            productId: product.id,
          });
          return;
        }

        const detailsRoute = buildDetailsRoute(
          buildOfferParams(product, packingSelected, producerUrl),
        );

        console.log(`Navegando para: ${detailsRoute}`);
        navigate(detailsRoute, {
          state: {
            isExclusiveOffer,
            lkpAuctionDate: product.lkpAuctionDate,
          },
        });
      },
      [
        navigate,
        producerUrl,
        validateNavigationParams,
        buildOfferParams,
        buildDetailsRoute,
      ],
    );

    return {
      handleShowDetails,
    };
  };
